import React, {
  ReactNode,
  MouseEvent
} from 'react';
import classNames from 'classnames';
import './Tabs.css';
import { ContainerClass, Props } from "./interfaces";
import translit from './translit';
// analytics
import gtag from '../analytics/gtag.js';

class MainTabs extends React.Component<Props, {selectedTabIndex: number}> {
  readonly mainTabs: Array<{ id: number, title: string, content: Array<{ id: number, description: string }> }>;

  constructor(props: Props) {
    super(props);
    this.mainTabs = this.props.mainTabs ? this.props.mainTabs : [];
    this.state = {
      selectedTabIndex: +this.mainTabs[0].id,
    };
    this.onTabClick = this.onTabClick.bind(this);
  }

  onTabClick(ev: MouseEvent): void {
    let newIndex: string | null | number = ev.currentTarget.getAttribute("data-index");
    if (newIndex) {
      this.setState({ ...this.state, selectedTabIndex: +newIndex });
      const tab = this.mainTabs.find(tab => tab.id === newIndex)
      gtag('event', 'click', {
        'event_category' : 'vacancy_tab',
        'event_label' : `vacancy_tab_${this.transliterate(tab!.title)}`
      });
    }
  }

  tabHeadView(title: string, tabIndex: number): ReactNode {
    const { selectedTabIndex } = this.state;
    const klass = {
      selected: selectedTabIndex === +tabIndex,
      head: true
    }

    return (
      <div
        className={classNames(klass)}
        key={`tab-head-${tabIndex}`}
        onClick={this.onTabClick}
        data-index={tabIndex}>
          <div className="tab-head-inner">
            {title}
          </div>
      </div>
    );
  }

  tabBodyView(title: string, content: Array<{ id: number, description: string }>, tabIndex: number): ReactNode {
    const { selectedTabIndex } = this.state;

    const klass = {
      selected: selectedTabIndex === +tabIndex,
      'tab-content': true,
      body: true,
    }

    return (
      <React.Fragment key={`tab-body-${tabIndex}`}>
        <h4  className="mobile-visible tab-title bold">{title}</h4>
        <div
          id={`tab-content-${tabIndex}` }
          className={classNames(klass)}
          key={`tab-body-${tabIndex}`}>
            <ul>
              {content.map((item) => <li key={item.id}>{item.description}</li>)}
            </ul>
        </div>
      </React.Fragment>
    );
  }

  tabHeads(mainTabs: Array<{ id: number, title: string, content: Array<{ id: number, description: string }> }>): ReactNode {
    return (
        <>
          { mainTabs.map((t) => this.tabHeadView(t.title, t.id)) }
        </>
    );
  }

  tabBodies(mainTabs: Array<{ id: number, title: string, content: Array<{ id: number, description: string }> }>): ReactNode {
    return (
        <>
          { mainTabs.map((t) => this.tabBodyView(t.title, t.content, t.id)) }
        </>
    );
  }

  private transliterate(word: string): string {
    const dict: {[key: string]: string} = translit;
    const delimeter = '';
    return word.toLowerCase().split(delimeter).map((char) => dict[char] || char).join(delimeter);
  }

  render(): JSX.Element | null {
    const { children } = this.props;
    if (!this.mainTabs || !this.mainTabs.length) return null;

    return (
      <div className="tabs">
        { children }
        <div className={ContainerClass.Heads}>
          { this.tabHeads(this.mainTabs) }
        </div>
        <div className={ContainerClass.Bodies}>
          { this.tabBodies(this.mainTabs) }
        </div>
      </div>
    );
  }
}

export default MainTabs;
